<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title" /> -->
        <v-row>
          <v-col>
            <v-card
              class="pt-3 pb-6"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'"
            >
              <v-container class="py-0">
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="header"
                      :items="execlist"
                      class="elevation-2 fix-font"
                      sort-by="order"
                      :sortDesc="true"
                      mobile-breakpoint="0"
                      :items-per-page="-1"
                      hide-default-header
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title
                            >รายชื่อผู้มีสิทธิเซ็นรับรอง(ระดับผู้บริหาร)</v-toolbar-title
                          >

                          <v-spacer></v-spacer>
                          <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="primary"
                                dark
                                class="mb-2"
                                v-bind="attrs"
                                v-on="on"
                              >
                                เพิ่ม
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="headline"
                                  >เพิ่มผู้มีสิทธิเซ็นรับรอง(ระดับผู้บริหาร)</span
                                >
                              </v-card-title>

                              <v-card-text>
                                <v-container>
                                  <v-select
                                    v-model="exec"
                                    :items="execSelectData"
                                    label="ชื่อผู้ลงนาม"
                                    :item-text="'employeeNamePosition' + $lang"
                                    item-value="employeeID"
                                    outlined
                                    dense
                                    hide-details
                                    return-object
                                    class="py-2"
                                  ></v-select>
                                  <div
                                    v-if="exec.positionNameTha"
                                    class="px-2 pt-1"
                                  >
                                    ตำแหน่ง :
                                    <span class="grey--text">{{
                                      exec[`positionName${$lang}`] +
                                        ' ' +
                                        exec[
                                          `organizationExecLevel1Name${$lang}`
                                        ]
                                    }}</span>
                                  </div>
                                  <!-- <div v-if="exec.exec" class="px-2 pt-1">
                                    ตำแหน่ง :
                                    <span class="grey--text">{{
                                      exec.exec
                                    }}</span>
                                  </div> -->
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="dialog = false"
                                >
                                  ยกเลิก
                                </v-btn>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  :disabled="!exec"
                                  @click="apiPostSign()"
                                >
                                  ยืนยัน
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                      </template>
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th
                              v-for="item in headers"
                              :key="item.text"
                              class="text-center text-body-1"
                            >
                              {{ item.text }}
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr
                            v-for="item in items"
                            :key="item.tbReqFormId"
                            class="text-center"
                          >
                            <td class="text-start">
                              {{ item[`employeeNamePosition${$lang}`] }}
                            </td>
                            <td>
                              {{
                                item[`positionExecName${$lang}`]
                                  ? item[`positionExecName${$lang}`]
                                  : '-'
                              }}
                            </td>
                            <td>
                              {{
                                item[`organizationExecLevel1Name${$lang}`]
                                  ? item[`organizationExecLevel1Name${$lang}`]
                                  : '-'
                              }}
                            </td>
                            <td>
                              <v-icon
                                color="error"
                                @click="deleteDialog(item.tbReqFormId)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="dialogDelete" max-width="320" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">ต้องการลบรายชื่อหรือไม่</div>

        <div class="text-end pb-4 pr-4">
          <v-btn
            class="mx-1"
            color="error"
            depressed
            @click="apiDeleteSign(idToDelete)"
          >
            ลบ
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="dialogDelete = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      idToDelete: null,
      title: 'ผู้มีสิทธิเซ็นรับรอง(บริหาร)',
      exec: '',
      execSelectData: [],
      execlist: []
    }
  },

  computed: {
    header() {
      return [
        { text: 'ชื่อ', value: `employeeNamePosition${this.$lang}` },
        { text: 'ตำแหน่ง', value: `positionExecName${this.$lang}` },
        { text: 'สังกัด', value: `organizationExecLevel1Name${this.$lang}` },
        { text: 'ลบ', value: 'actions', sortable: false }
      ]
    }
    // filterExecSelectData() {
    //   return this.execSelectData.filter(item => {
    //     for (var i = 0; i < this.execlist.length; i++) {
    //       if (this.execlist[i].Name == 'Magenic') {
    //         item = true
    //         break
    //       }
    //     }
    //   })
    // }
  },
  async mounted() {
    this.initialinfo()
  },
  methods: {
    deleteDialog(id) {
      this.dialogDelete = true
      this.idToDelete = id
    },
    async initialinfo() {
      this.execSelectData = await this.apiGetExecList()
      const res = await this.apiGetSignList()
      this.execlist = res.sigeModelView
    },
    async apiGetExecList() {
      try {
        const res = await this.$store.dispatch('reqCer/getExecList')
        // console.log(res)

        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiGetSignList() {
      try {
        const res = await this.$store.dispatch('reqCer/getSignList')
        // console.log(res)
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiPostSign() {
      try {
        const res = await this.$store.dispatch('reqCer/addSign', {
          EmployeeID: this.exec.employeeID
        })
        this.exec = {}
        this.dialog = false
        this.initialinfo()
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiDeleteSign(id) {
      try {
        const res = await this.$store.dispatch('reqCer/deleteSign', id)
        this.initialinfo()
        this.dialogDelete = false
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>

<style scoped>
.fix-font {
  white-space: nowrap;
}
</style>
